export const STATUSES = {
  EMPTY: 'empty',
  UPLOADING: 'uploading', // direct upload request + bucket upload + text extraction
  PARSING: 'parsing', // Contact details and answer suggestions request
  FAILED: 'failed',
  MISSING_CONTACT_DETAILS: 'missing_contact_details',
  NOT_SUPPORTED_FILE: 'not_supported_file', // Type or size not supported
  INVALID_FILE: 'invalid_file', // Not a resume
  SUCCESS: 'success'
};

export const ACCEPTED_FILE_TYPES = [
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  'application/pdf'
];

export const ANIMATION_DEFAULT_OPTIONS = {
  loop: true,
  autoplay: true,
};

export const TRY_AGAIN_STATUSES = [
  STATUSES.FAILED,
  STATUSES.MISSING_CONTACT_DETAILS,
  STATUSES.NOT_SUPPORTED_FILE,
  STATUSES.INVALID_FILE
];
